import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import deepEqual from 'fast-deep-equal'
import helpers from 'core/helpers'
import helpersDigitalSignages from 'core/helpers/_digitalSignages'
import { getThemeStyleValue } from '../../../../theme/colors'
import { defaultThemeStyles as defaultThemeSidebarStyles } from 'blocks.app/sidebar/Sidebar-theme'

interface ISelectedInfo {
    id: number
    type: string
    settings: {
        autoScreenshot: {
            width: number
            height: number
            enabled: boolean
            interval: number
        }
    }
    online?: boolean
    screenshots?: { createdAt: string }[]
    __type?: string
    name?: string
    url?: string
    createdAt?: string
    resolutionHeight?: number
    resolutionWidth?: number
    status: string
}
export interface IShotsSidebarProps {
    selectedInfo: ISelectedInfo
    startUpdateAnimation: () => void
    emitError: (error: string) => void
    onChangeActive: (data: any) => void
    uploadDigitalSignageAndGroupMedia: (data: { formData: FormData; cb: () => void }) => void
    minimized: boolean
    toggleMinimized: () => void
    onClose: () => void
}
interface IState {
    active: { __type: string; id: number } | null
    selected: number[]
    selectedMedia: number[]
    screenshots: { createdAt: string; id: number; url: string }[]
    total: number
    isLoading: boolean
    startDate: moment.Moment
    endDate: moment.Moment
    height: number
    autoScreenshot: {
        enabled: boolean
        interval: number
        width: number
        height: number
    }
    media: { createdAt: string; id: number; url: string }[]
    totalMedia: number
    activeTab: string
    isLoadingMedia: boolean
    historyList?: {}[]
}

const dates = {
    startDate: moment(),
    endDate: moment(),
}

const defaultAutoScreenShotSettings = {
    enabled: false,
    interval: 5000,
    width: 1920,
    height: 1080,
}

let autoScreenShotTimer: any = null

export const DisplaysScreenShotsSidebarMethods = (p_: IShotsSidebarProps) => {
    const [state, setState] = useState<IState>({
        active: null,
        selected: [],
        selectedMedia: [],
        screenshots: [],
        total: 0,
        isLoading: true,
        ...dates,
        height: 0,
        autoScreenshot: defaultAutoScreenShotSettings,
        media: [],
        totalMedia: 0,
        activeTab: 'screenshotsHistory',
        isLoadingMedia: false,
    })
    const [prevProps, setPrevProps] = useState<IShotsSidebarProps>(p_)
    const fileInputRef = useRef<any>(null)
    const tabs = [
        { id: 'screenshotsHistory', label: translate('screenshotsHistory') },
        { id: 'installation', label: translate('installation') },
    ]

    useEffect(() => {
        getMedia()

        if (p_.selectedInfo.type !== 'group') {
            getScreenshots()
            getAutoScreenShotSettings()
        }

        if (p_.selectedInfo.type === 'group') {
            setState((prevState) => {
                return {
                    ...prevState,
                    activeTab: 'installation',
                }
            })
        }
    }, [])

    const getMedia = (isLazyLoad?: boolean) => {
        const data = {
            offset: isLazyLoad ? (state.historyList ? state.historyList.length : 0) : 0,
            perPage: 20,
            [`${p_.selectedInfo.type}Id`]: p_.selectedInfo.id,
        }

        api.send('getDigitalSignageAndGroupMedia', data).then((res: any) => {
            let media = res.data
            media.forEach((item: { __type: string }) => {
                item.__type = 'installation'
            })

            if (isLazyLoad) {
                media = [...state.media, ...media]
            }

            setState((prevState) => {
                return {
                    ...prevState,
                    media,
                    total: res.total,
                }
            })
        })
    }
    const getAutoScreenShotSettings = () => {
        const { selectedInfo } = p_

        if (selectedInfo.settings && selectedInfo.settings.autoScreenshot) {
            setState((prevState) => {
                return {
                    ...prevState,
                    autoScreenshot: {
                        ...selectedInfo.settings.autoScreenshot,
                    },
                }
            })

            setAutoScreenShotTimer(selectedInfo.settings.autoScreenshot, selectedInfo)
        }
    }

    const setAutoScreenShotSettings = (value: number | boolean, field: string) => {
        if (field === 'interval') {
            value = Number(value)
            value *= 1000
        }

        const s_ = { ...state }

        // @ts-ignore
        s_.autoScreenshot[field] = value

        setAutoScreenShotTimer(state.autoScreenshot, p_.selectedInfo)

        setState((prevState) => {
            return {
                ...prevState,
                ...s_,
            }
        })
    }

    const setAutoScreenShotSettingsWidthHeight = (value: number, field: string, max: number) => {
        if (field === 'width') {
            state.autoScreenshot.width = value
            if (!max) {
                return
            }
            setAutoScreenShotTimer(state.autoScreenshot, p_.selectedInfo)
        } else {
            state.autoScreenshot.height = value
            if (!max) {
                return
            }
            setAutoScreenShotTimer(state.autoScreenshot, p_.selectedInfo)
        }

        setState((prevState) => {
            return {
                ...prevState,
                ...state,
            }
        })
    }

    const saveAutoScreenShotSettings = () => {
        const { selectedInfo } = p_

        if (helpersDigitalSignages.isFolder(selectedInfo)) {
            return
        }

        if (!deepEqual(selectedInfo.settings.autoScreenshot, state.autoScreenshot)) {
            api.send('editDisplay', {
                settings: { ...selectedInfo.settings, autoScreenshot: state.autoScreenshot },
                id: selectedInfo.id,
            })
        }
    }

    const setAutoScreenShotTimer = (
        settings: {
            enabled: boolean
            interval: number
            width: number
            height: number
            autoScreenshot?: boolean
        } | null,
        item: ISelectedInfo
    ) => {
        if (!helpers.isAvailableAction(p_.selectedInfo, { key: 'digitalSignage', action: 'update' })) {
            return
        }

        if (!settings) {
            settings = state.autoScreenshot
        }
        //console.log(settings.enabled)
        console.log(item && item.online && settings.enabled)
        if (item && item.online && settings.enabled) {
            clearInterval(autoScreenShotTimer)

            autoScreenShotTimer = setInterval(() => {
                if (settings && settings.interval < defaultAutoScreenShotSettings.interval) {
                    clearInterval(autoScreenShotTimer)
                    p_.emitError('intervalCantBeLessFiveSeconds')
                    return
                }

                p_.startUpdateAnimation()

                api.send('updateScreenshotCb', {
                    id: item.id,
                    width: settings && settings.width ? settings.width : 1920,
                    height: settings && settings.height ? settings.height : 1080,
                })
            }, settings.interval)
        } else {
            clearInterval(autoScreenShotTimer)
        }
    }
    const isSameOrBeforeDates = (current: string) => {
        const currentFormat = moment(current).format('YYYY-MM-DD')
        const startDateFormat = moment(state.startDate).format('YYYY-MM-DD')

        return moment(startDateFormat).isSameOrBefore(moment(currentFormat))
    }

    useEffect(() => {
        if (
            !deepEqual(p_.selectedInfo.screenshots, prevProps.selectedInfo.screenshots) &&
            moment(dates.endDate).isSameOrBefore(state.endDate)
        ) {
            const screenshots = p_.selectedInfo!.screenshots!.filter((screenshot) =>
                isSameOrBeforeDates(screenshot.createdAt)
            )

            setState((prevState: any) => {
                return {
                    ...prevState,
                    screenshots,
                }
            })

            setPrevProps(p_)

            if (screenshots.length && state.activeTab !== 'installation') {
                setActiveMedia(screenshots[0])
            }
        }

        if (p_.selectedInfo.online !== prevProps.selectedInfo.online) {
            setAutoScreenShotTimer(null, p_.selectedInfo)
        }
    }, [p_, prevProps])

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver('digitalSignageScreenshotDeleted', onDigitalSignageScreenshotDeleted, listenersId)
        api.addObserver('digitalSignageAndGroupMediaCreated', onDigitalSignageAndGroupMediaCreated, listenersId)
        api.addObserver('digitalSignageAndGroupMediaDeleted', onDigitalSignageAndGroupMediaDeleted, listenersId)

        return () => {
            if (helpers.isAvailableAction(p_.selectedInfo, { key: 'digitalSignage', action: 'update' })) {
                saveAutoScreenShotSettings()
            }

            listenersId.forEach((id) => api.removeObserver(id))
            clearInterval(autoScreenShotTimer)
        }
    }, [])

    const getScreenshots = (isLazyLoad?: boolean, filter = {}) => {
        const data = {
            offset: isLazyLoad ? state.screenshots.length : 0,
            perPage: 20,
            digitalSignageId: p_.selectedInfo.id,
            ...filter,
        }

        setState((prevState) => {
            return {
                ...prevState,
                isLoading: true,
            }
        })

        api.send('getDigitalSignageScreenshots', data).then((res: any) => {
            const data = {
                screenshots: res.data,
                total: res.total,
            }

            if (!res.data.length) {
                data.screenshots = []
            }

            setState((prevState) => {
                return {
                    ...prevState,
                    ...data,
                    isLoading: false,
                }
            })

            if (!isLazyLoad) {
                if (res.data.length) {
                    setActiveMedia(res.data[0])
                }
            }
        })
    }

    const onDigitalSignageScreenshotDeleted = (item: ISelectedInfo) => {
        onScreenShotDeleted(item)
    }

    const onDigitalSignageAndGroupMediaCreated = (item: ISelectedInfo) => {
        onMediaCreated(item)
    }

    const onDigitalSignageAndGroupMediaDeleted = (item: ISelectedInfo) => {
        onMediaDeleted(item)
    }

    const onScreenShotDeleted = (item: ISelectedInfo) => {
        const screenshots = state.screenshots.filter((screen) => screen.id !== item.id)
        const selected = state.selected.filter((media) => media !== item.id)
        const data: {
            selected: number[]
            screenshots: { id: number }[]
            active?: null
        } = {
            screenshots,
            selected,
        }

        if (state.active && state.active.__type !== 'installation' && item.id === state.active.id) {
            data.active = null
            p_.onChangeActive({ caption: '', image: '', type: '' })
        }

        setState((prevState: any) => {
            return {
                ...prevState,
                ...data,
            }
        })
    }
    const onMediaCreated = (item: ISelectedInfo) => {
        item.__type = 'installation'

        setState((prevState: any) => {
            return {
                ...prevState,
                media: [...state.media, item],
            }
        })
    }
    const onMediaDeleted = (item: ISelectedInfo) => {
        const media = state.media.filter((media) => media.id !== item.id)
        const selectedMedia = state.selectedMedia.filter((media) => media !== item.id)
        const data: {
            media: { id: number }[]
            selectedMedia: number[]
            active?: null
        } = {
            media,
            selectedMedia,
        }

        if (state.active && state.active.__type === 'installation' && item.id === state.active.id) {
            data.active = null
            p_.onChangeActive({ caption: '', image: '', type: '' })
        }

        setState((prevState: any) => {
            return {
                ...prevState,
                ...data,
            }
        })
    }

    const setActiveMedia = (item: { createdAt: string; url?: string }) => {
        const typeLabel =
            state.activeTab === 'installation' ? translate('installation').toLowerCase() : translate('screen')
        const caption = `${p_.selectedInfo.name}, ${typeLabel} ${moment(item.createdAt).format('DD/MM/YYYY HH:mm')}`
        const image = item.url
        const active = {
            ...item,
            __type: state.activeTab,
        }

        p_.onChangeActive({ ...active, caption, image })

        setState((prevState: any) => {
            return {
                ...prevState,
                active,
            }
        })
    }
    const onDelete = () => {
        api.send('deleteDigitalSignageScreenshot', { id: state.selected })
    }
    const onDeleteMedia = () => {
        api.send('deleteDigitalSignageAndGroupMedia', { id: state.selectedMedia })
    }
    const onFilter = () => {
        const startDate = moment(state.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
        const endDate = moment(state.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')

        getScreenshots(false, { startDate, endDate })
    }
    const openFileInput = () => {
        if (!state.isLoadingMedia && fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    const onFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files

        if (!files || files.length === 0) {
            return
        }

        setState((prevState) => {
            return {
                ...prevState,
                isLoadingMedia: true,
            }
        })

        const formData = new FormData()
        const type = `${p_.selectedInfo.type}Id`

        formData.append('file', files[0])
        formData.append(type, p_.selectedInfo.id.toString())

        p_.uploadDigitalSignageAndGroupMedia({
            formData,
            cb: () => {
                setState((prevState) => {
                    return {
                        ...prevState,
                        isLoadingMedia: false,
                    }
                })

                if (fileInputRef.current) {
                    fileInputRef.current.value = ''
                }
            },
        })
    }

    const onSelectAll = () => {
        if (state.selected.length === state.screenshots.length) {
            setState((prevState) => {
                return {
                    ...prevState,
                    selected: [],
                }
            })

            return
        }

        setState((prevState) => {
            return {
                ...prevState,
                selected: state.screenshots.map((screenshot) => screenshot.id),
            }
        })
    }

    const getSelectAllIconProps = () => {
        const props = {
            type: 'checked',
            size: 18,
            color: getThemeStyleValue('sidebar', 'screenshot', 'text') || defaultThemeSidebarStyles['screenshot-text'],
            tooltip: {
                title: translate('selectAll'),
            },
        }

        if (!state.screenshots.length) {
            return props
        }

        if (state.selected.length === state.screenshots.length) {
            props.type = 'close'
            props.tooltip = {
                title: translate('deselect'),
            }
        }

        return props
    }

    return {
        state,
        setState,
        getSelectAllIconProps,
        tabs,
        openFileInput,
        fileInputRef,
        onFileInputChange,
        onDeleteMedia,
        setAutoScreenShotSettings,
        setAutoScreenShotSettingsWidthHeight,
        onFilter,
        onSelectAll,
        onDelete,
        getScreenshots,
        setActiveMedia,
        getMedia,
    }
}
